import { registerBetLogFormatter, betLogNotFormatted } from '../../sharedF/betterConsLogF.mts'

registerBetLogFormatter((arg, key) => {
  if (key == 'finishedTrails') return 'omitted'
  return betLogNotFormatted
})
